import * as React from 'react'
import { Button } from './Button'
import { cn } from '@/lib/utils'

export type BulkSelectBarProps = {
  selectedCount: number
  totalCount: number
  onSelectPage?: () => void
  onSelectAll?: () => void
  onClear?: () => void
  onDelete?: () => void
  className?: string
}

export function BulkSelectBar({ selectedCount, totalCount, onSelectPage, onSelectAll, onClear, onDelete, className }: BulkSelectBarProps) {
  if (totalCount <= 0) return null
  return (
    <div className={cn('mb-3 flex flex-wrap items-center justify-between gap-2 rounded-md border border-border/60 bg-card p-2 text-sm', className)}>
      <div>
        {selectedCount > 0 ? (
          <span><strong>{selectedCount}</strong> selecionado(s) de <strong>{totalCount}</strong></span>
        ) : (
          <span>Selecione itens para ações em massa</span>
        )}
      </div>
      <div className="flex items-center gap-2">
        {onSelectPage && <Button variant="outline" onClick={onSelectPage}>Selecionar página</Button>}
        {onSelectAll && <Button variant="outline" onClick={onSelectAll}>Selecionar resultado</Button>}
        {onClear && <Button variant="outline" onClick={onClear}>Limpar</Button>}
        {onDelete && <Button variant="destructive" disabled={selectedCount===0} onClick={onDelete}>Excluir selecionados</Button>}
      </div>
    </div>
  )
}

